import {NuqsAdapter} from 'nuqs/adapters/react';
import React from 'react';
import {Provider} from 'react-redux';
import {Loader} from 'semantic-ui-react';

import {apolloClient} from './apolloClient';
import config, {envIsIntegration} from './config';
import {apolloClient2, store} from './setup';
import {ApolloProvider} from './state/graphql/apolloWithAbort';
import {Apollo2Context} from './util/apollo2-hooks';

async function fetchOverridesWithRetry(retries = 5): Promise<Response> {
  try {
    // oxlint-disable-next-line wandb/no-unprefixed-urls
    const response = await fetch(
      `${config.LOCAL_TEST_FIXTURE_SERVER_HOST}/app-config-override`,
      {method: 'GET'}
    );

    if (response.ok) {
      return response;
    }

    throw new Error(`Failed to fetch config overrides: ${response.status}`);
  } catch (error) {
    if (retries > 0) {
      return fetchOverridesWithRetry(retries - 1);
    }
    throw error;
  }
}

const ConfigOverrideProvider: React.FC<{
  children?: React.ReactNode;
}> = props => {
  const [loading, setLoading] = React.useState(
    envIsIntegration && !!config.LOCAL_TEST_FIXTURE_SERVER_HOST
  );

  React.useEffect(() => {
    if (!loading) {
      return;
    }

    fetchOverridesWithRetry().then(async response => {
      Object.assign(config, await response.json());
      setLoading(false);
    });
  }, [loading]);

  if (loading) {
    return <Loader name="config-override-loader" />;
  }

  return <>{props.children}</>;
};

export const AppEntryProviders: React.FC<{
  children?: React.ReactNode;
}> = ({children}) => (
  <NuqsAdapter>
    <ConfigOverrideProvider>
      <Provider store={store}>
        <ApolloProvider client={apolloClient}>
          <Apollo2Context.Provider value={apolloClient2}>
            {children}
          </Apollo2Context.Provider>
        </ApolloProvider>
      </Provider>
    </ConfigOverrideProvider>
  </NuqsAdapter>
);
